import { NiaraIcon, NiaraIconNameType } from '@niaratech/niara-icons';
import React, { ReactElement, useContext } from 'react';
import { IcChevronAccordion } from '../../Icons';
import { AccordionContext } from './Accordion';
import * as S from './styles';
export type AccordionType = React.PropsWithChildren<S.OpenTabProps & {
  expandIcon?: string;
  icon?: string;
  niaraIcon?: NiaraIconNameType;
  id: number;
  header?: ReactElement | string;
  transition?: boolean;
  sizeTitle?: number;
}>;
const Panel: React.FC<AccordionType> = ({
  children,
  expandIcon = IcChevronAccordion,
  icon,
  niaraIcon,
  id,
  sizeHeaderText = 13,
  paddingHeader,
  paddingHeaderY,
  childrenPaddingX,
  childrenPaddingY,
  header,
  colorDivider,
  transition,
  sizeTitle
}) => {
  const {
    activeTab,
    handleChange
  } = useContext(AccordionContext);
  return <S.Tab colorDivider={colorDivider}>
      <S.Hero sizeHeaderText={sizeHeaderText} onClick={() => {
      handleChange(id);
    }} paddingHeader={paddingHeader} paddingHeaderY={paddingHeaderY}>
        <S.Header>
          {niaraIcon ? <NiaraIcon icon={niaraIcon} size={24} /> : icon && <S.Icon src={icon} alt="icon" />}

          {typeof header === 'string' ? <S.Title sizeTitle={sizeTitle}>{header}</S.Title> : header}
        </S.Header>

        {expandIcon === 'sysAngleDown' ? <S.RotatingIcon data-testid="rotating-icon-btn" icon={expandIcon} size={24} className={`chevron-animation ${activeTab.includes(id) ? 'open' : 'closed'}`} /> : <S.ExpandIcon data-testid="expand-icon-btn" src={expandIcon} alt="chevron" isOpen={activeTab.includes(id)} />}
      </S.Hero>
      <S.Content isOpen={activeTab.includes(id)} childrenPaddingX={childrenPaddingX} childrenPaddingY={childrenPaddingY} transition={transition}>
        {children}
      </S.Content>
    </S.Tab>;
};
export default Panel;